"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "typographyStyles", {
    enumerable: true,
    get: function() {
        return typographyStyles;
    }
});
const _tokens = require("../tokens.js");
const typographyStyles = {
    body1: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase300,
        fontWeight: _tokens.tokens.fontWeightRegular,
        lineHeight: _tokens.tokens.lineHeightBase300
    },
    body1Strong: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase300,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightBase300
    },
    body1Stronger: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase300,
        fontWeight: _tokens.tokens.fontWeightBold,
        lineHeight: _tokens.tokens.lineHeightBase300
    },
    body2: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase400,
        fontWeight: _tokens.tokens.fontWeightRegular,
        lineHeight: _tokens.tokens.lineHeightBase400
    },
    caption1: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase200,
        fontWeight: _tokens.tokens.fontWeightRegular,
        lineHeight: _tokens.tokens.lineHeightBase200
    },
    caption1Strong: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase200,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightBase200
    },
    caption1Stronger: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase200,
        fontWeight: _tokens.tokens.fontWeightBold,
        lineHeight: _tokens.tokens.lineHeightBase200
    },
    caption2: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase100,
        fontWeight: _tokens.tokens.fontWeightRegular,
        lineHeight: _tokens.tokens.lineHeightBase100
    },
    caption2Strong: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase100,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightBase100
    },
    subtitle1: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase500,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightBase500
    },
    subtitle2: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase400,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightBase400
    },
    subtitle2Stronger: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase400,
        fontWeight: _tokens.tokens.fontWeightBold,
        lineHeight: _tokens.tokens.lineHeightBase400
    },
    title1: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeHero800,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightHero800
    },
    title2: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeHero700,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightHero700
    },
    title3: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeBase600,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightBase600
    },
    largeTitle: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeHero900,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightHero900
    },
    display: {
        fontFamily: _tokens.tokens.fontFamilyBase,
        fontSize: _tokens.tokens.fontSizeHero1000,
        fontWeight: _tokens.tokens.fontWeightSemibold,
        lineHeight: _tokens.tokens.lineHeightHero1000
    }
};
